import React from 'react';
import { 
  BarChart3, 
  Sparkles, 
  Target, 
  TrendingUp, 
  Users, 
  MessageSquare, 
  Zap,
  LineChart
} from 'lucide-react';

export default function FeatureSection() {
  const features = [
    {
      icon: <BarChart3 className="w-6 h-6" />,
      title: 'Campaign Performance Analysis',
      description: 'Monitor and analyze the performance of campaigns across all your marketing channels in real-time.'
    },
    {
      icon: <Sparkles className="w-6 h-6" />,
      title: 'AI-Powered Insights',
      description: 'Artificial intelligence algorithms analyze your data to provide recommendations that improve your marketing strategy.'
    },
    {
      icon: <Target className="w-6 h-6" />,
      title: 'Audience Segmentation',
      description: 'Automatically segment your customers based on their behaviors, demographics, and interactions.'
    },
    {
      icon: <TrendingUp className="w-6 h-6" />, 
      title: 'ROI Optimization',
      description: 'Intelligently distribute your marketing budget to channels that provide the highest return.'
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: 'Customer Journey Analysis',
      description: 'Track your customers\' purchase journey and identify optimization opportunities at every step.'
    },
    {
      icon: <MessageSquare className="w-6 h-6" />,
      title: 'Content Recommendations',
      description: 'Deliver the most effective messages to your target audience with AI-powered content recommendations.'
    },
    {
      icon: <Zap className="w-6 h-6" />,
      title: 'Automated Campaign Optimization',
      description: 'Save time with AI algorithms that automatically optimize your campaigns.'
    },
    {
      icon: <LineChart className="w-6 h-6" />,
      title: 'Predictive Analytics',
      description: 'Develop proactive strategies with AI models that predict future marketing trends and results.'
    }
  ];

  return (
    <div className="py-24 bg-white relative overflow-hidden">
    
    </div>
  );
} 